(function () {
  const productListSelector = '.product-grid';
  const paginationSelector = '.pagination';

  function getNextLink(doc) {
    const links = doc.querySelectorAll('.pagination a[href*="page"]');
    return links.length ? links[links.length - 1] : null;
  }

  let loading = false;
  let nextUrl = null;

  const initialLink = getNextLink(document);
  if (initialLink) nextUrl = initialLink.href;

  const pagination = document.querySelector(paginationSelector);
  if (pagination) pagination.style.display = 'none';

  async function loadMore() {
    if (loading || !nextUrl) return;
    loading = true;

    console.log('Loading:', nextUrl);

    try {
      const response = await fetch(nextUrl);
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');

      const newItems = doc.querySelectorAll('.product-grid > .product-card');
      const currentList = document.querySelector(productListSelector);

      if (currentList && newItems.length) {
        newItems.forEach((item) => {
          item.style.opacity = '0';
          item.style.transform = 'translateY(16px)';
          item.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
          currentList.appendChild(item);

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              item.style.opacity = '1';
              item.style.transform = 'translateY(0)';
            });
          });
        });
      }

      const newNextLink = getNextLink(doc);
      if (newNextLink) {
        nextUrl = newNextLink.href;
        console.log('Next page will be:', nextUrl);
      } else {
        nextUrl = null;
        console.log('No more pages.');
        observer.disconnect();
      }

    } catch (err) {
      console.error('Infinite scroll error:', err);
    } finally {
      loading = false;
    }
  }

  const sentinel = document.createElement('div');
  sentinel.id = 'scroll-sentinel';
  sentinel.style.height = '1px';
  if (pagination) {
    pagination.parentNode.insertBefore(sentinel, pagination);
  } else {
    document.querySelector(productListSelector)?.insertAdjacentElement('afterend', sentinel);
  }

  const observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) loadMore();
    },
    { rootMargin: '200px' }
  );

  if (nextUrl) {
    observer.observe(sentinel);
  }
})();